import { type JSX } from 'react'
import { StyledFilterChipSquarish } from './FilterChipSquarish.styled'

export type FilterChipProps = {
  label: string
  selected: boolean
  icon?: JSX.Element
  onClick: () => void
}
// `aria-pressed` carried by the component, not by its callers: `selected` only
// reaches the style, so without it a screen reader cannot tell which chip of a
// group is active.
export const FilterChipSquarish = (props: FilterChipProps) => (
  <StyledFilterChipSquarish {...props} aria-pressed={props.selected} />
)
